import { createStyles } from '@mantine/core';

import {
  MARKET_CELL_HEIGHT,
  MARKET_CELL_WIDTH_DESKTOP,
  MARKET_CELL_WIDTH_MOBILE,
} from '../../constants/marketCell';

export const useStyles = createStyles((theme) => ({
  cardLink: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',

    '&:hover': {
      textDecoration: 'none',
      color: 'inherit',
    },
  },

  gameDetails: {
    color: 'inherit',
  },

  container: {
    backgroundColor: theme.white,
    borderRadius: theme.radius.lg,
    padding: theme.other.spacing._16,
    cursor: 'pointer',
    transition: 'box-shadow 0.5s ease',
    minHeight: 120,
    width: '100%',

    '&:hover': {
      boxShadow: `0 2px 8px ${theme.black}14`,
    },
  },

  notClickable: {
    '&:hover': {
      boxShadow: `0 2px 8px ${theme.black}14`,
      transform: 'none',
    },
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.other.spacing._16,
  },

  periodContainer: {
    flex: 1,
  },

  broadcastIcon: {
    color: theme.colors.red[5],
    display: 'flex',
    alignItems: 'center',
  },

  marketHeaderSpacer: {
    flex: 1,
  },

  marketHeaders: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.other.spacing._4,
  },

  marketHeaderCell: {
    width: MARKET_CELL_WIDTH_MOBILE,
    textAlign: 'center',

    [theme.fn.largerThan('sm')]: {
      width: 'auto',
      minWidth: `var(--market-cell-min-width, ${MARKET_CELL_WIDTH_DESKTOP}px)`,
    },
  },

  teamsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._12,
  },

  teamInfo: {
    flex: 1,
  },

  teamNameShort: {
    [theme.fn.largerThan('sm')]: {
      display: 'var(--market-team-name-short-display, none)',
    },
  },

  teamNameFull: {
    display: 'none',

    [theme.fn.largerThan('sm')]: {
      display: 'var(--market-team-name-full-display, inline)',
    },
  },

  teamLogo: {
    flexShrink: 0,
    width: 28,
    height: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },

  cellLocked: {
    cursor: 'not-allowed',
    opacity: 0.5,
    transition: 'none',
  },

  marketCell: {
    width: MARKET_CELL_WIDTH_MOBILE,
    height: MARKET_CELL_HEIGHT,
    backgroundColor: theme.colors.gray2[0],
    color: theme.colors.gray2[9],
    borderRadius: theme.radius.sm,
    padding: `${theme.other.spacing._4}px ${theme.other.spacing._16}px`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    gap: theme.other.spacing._2,
    cursor: 'pointer',
    transition: 'background-color 0.15s ease, color 0.15s ease',

    [theme.fn.largerThan('sm')]: {
      flexDirection: 'var(--market-cell-direction, row)' as 'row',
      gap: `var(--market-cell-gap, ${theme.other.spacing._8}px)`,
      width: 'auto',
      minWidth: `var(--market-cell-min-width, ${MARKET_CELL_WIDTH_DESKTOP}px)`,
      padding: `var(--market-cell-padding, ${theme.other.spacing._4}px ${theme.other.spacing._16}px)`,
    },

    '&:hover:not([data-selected="true"])': {
      backgroundColor: theme.other.color.gray.hover,
    },
  },

  marketCellSplit: {
    [theme.fn.largerThan('sm')]: {
      justifyContent: 'space-between',
    },
  },

  marketCellSelected: {
    backgroundColor: theme.colors.gray2[8],

    '&:hover': {
      backgroundColor: theme.colors.gray2[6],
    },
  },

  oddsPositive: {
    color: theme.colors.blue[7],
  },

  oddsNegative: {
    color: theme.colors.gray2[9],
  },
}));
